















































































  import { Component, Vue } from "vue-property-decorator";
  import DniBusiness from "@/components/dniBusiness/DniFieldBusiness.vue";
  import Modals from "@/components/modals/Modals.vue";
  import {
    Configuration,
    SelectedCountry,
    RedCapital,
    TitleTemplateDashboard,
  } from "@/configuration";
  import API from "@/api";
  import { EventBus } from "@/main";
  import { mapState } from "vuex";
  import { DniTrim } from "@/utils";

  @Component({
    computed: { ...mapState(["user"]) },
    metaInfo: {
      title: "Crear empresa",
      titleTemplate: TitleTemplateDashboard,
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang,
      },
    },
    data() {
      return {
        SelectedCountry,
        RedCapital,
        valid: true,
        dialog: false,
        form: {
          name: "",
          dni: "",
          phone: null,
          address: "",
          debt: "",
          web: "",
          description: "",
          radios: "siiPassword",
          folder: null,
          siiPassword: "",
          businessName: "",
          order: "",
          sales: null,
          id: this.$store.state.user.id,
        },
        rules: {
          noVacio: [
            // @ts-ignore
            v => {
              if(!v || v.trim() === ''){
                return 'Campo requerido'
              }else if(v.trim() === '0'){
                return 'Campo requerido'
              }else{
                return true
              }
            }
          ],
        },
        modalTipo: 0,
        isLoading: false,
      };
    },
    /* 
			Valida que el usuario logeado sea del tipo RedCapital
			del caso contrario es devuelto al Home de RC.
		*/
		beforeRouteEnter  (to, from, next) {
			next(vm => {
				if (vm.$store.state.user.via_id == 2){
					vm.$router.push('/')
				}
			});
		},
		beforeMount(){
			/* 
				Validamos que el usuario al menos una Empresa
				para poder redireccionarlo al panel principal.
			*/
			if(this.$store.state.user.empresas_count > 0){
				this.$router.push({
					path: "/panel-facto/estadisticas",
				});
			}
		},
    methods: {
      validate() {
        // @ts-ignore
        if (this.$refs.formCreateEmpresa.validate()) {
          this.$data.valid = true;
          this.$data.isLoading = true; // is loading btn
          
          let theTruth: any = {
            name: "nombre",
            dni: "rut",
            phone: "telefono",
            address: "direccion",
            debt: "deuda",
            web: "pagina_web",
            description: "descripcion",
            siiPassword: "clavesii",
            businessName: "razon_social",
            order: "giro",
            sales: "empresa_target_id",
            id: "user_id",
          };

          let payload: any = {};
          for (let key in this.$data.form) {
            if (theTruth[key] != undefined) {
              if (theTruth[key] == "rut") {
                payload[theTruth[key]] = DniTrim.string(this.$data.form[key]);
              } else {
                payload[theTruth[key]] = this.$data.form[key];
              }
            }
          }
          API.createBusiness(payload)
            .then((res: any) => {
              this.$data.dialog = true;
              this.$store.commit("setBusinessSelected", res);
              this.$store.commit("setBusiness", res.id);
              this.$store.commit("setEmpresasCount", +1);
              setTimeout(() => {
                this.$router.push({
                  path: "/panel-facto/estadisticas",
                });
              }, Configuration.Redirection.timeout);
            })
            .catch((err: any) => {
              EventBus.$emit("snack-error", "En este momento no se puede crear tu empresa, intentalo más tarde.");
            })
            .finally(() => {
              this.$data.dialog = false;
              this.$data.isLoading = false;
            })
          }
      },
      /* Nuevos Metodos */
      dataResponse(data){
        API.stateBusiness(this.$data.form.dni.split('.').join(''))
          .then((res:any)=>{
            if(res.data.message == "Crear"){ // Evalua si el rut ingresado se puede crear
              if(data.data.presenta_inicio_actividades == 'NO'){ // Evalua si tiene inicio de actividad para setar o no el valor de nombre
                // @ts-ignore
                this.$refs.form.reset();
                // @ts-ignore
                this.modal(2); // Modal Sin inicio de actividades
              }else{ 
                this.$data.form.name = data.data.razon_social;
              }
            } else { // Si no se puede crear despliega modal avisando que el rut ya esta registrado por la persona
              // @ts-ignore
              this.$refs.formCreateEmpresa.reset();
              // @ts-ignore
              this.modal(13);
            }
          })
          .catch((err:any)=>{
            if(err.response.data.message == 'Registada por 3ro'){ // Muestra mensaje indicando el rut fue registrado por otra persona
              // @ts-ignore
              this.$refs.formCreateEmpresa.reset();
              // @ts-ignore
              this.modal(12);
              //this.$data.btnSeleccionarEmpresa = false;
            }
          })
      },
      dataResponseVacio(){
        this.$data.form.name = '';
      },
      modal(tipo){
        this.$data.modalTipo = 0;
        setTimeout(() => {
          this.$data.modalTipo = tipo;	
        });
      },
      limpiarModal7(){
        // @ts-ignore
        this.$refs.formCreateEmpresa.reset();
      },
      showAlerta(data){ // Funcion necesaria para mostrar los snack bar de alertas
        if(data.tipo){
          EventBus.$emit("snack-success", data.mensaje);
        }else{
          EventBus.$emit("snack-error", data.mensaje);
        }
      },
    },
    components: {
      DniBusiness,
      Modals
    },
  })
  export default class NewCreateBusiness extends Vue {}
